import * as React from 'react';
import {
  Edit,
  SelectInput,
  SimpleForm,
  TextInput,
  DateInput,
  ImageInput,
  required,
  CheckboxGroupInput,
  ArrayInput,
  SimpleFormIterator,
  TextField,
} from 'react-admin';
import {
  admin_users,
  gender_typs,
  purpose_types,
  status_types,
} from '../../utils/choices';
import { initalMetas } from '../../utils/initalMetas';
const UserTitle = ({ record }) => {
  return (
    <span>User {record ? `"${record.name}"` : 'User name is empty :('}</span>
  );
};
const UploadedImages = ({ record }) => {
  if (typeof record === 'string') {
    return (
      <img src={record} alt="img" style={{ width: '300px', padding: '1em' }} />
    );
  } else {
    return (
      <img
        src={record.undefined}
        alt="img"
        style={{ width: '300px', padding: '1em' }}
      />
    );
  }
};

const FaceImage = ({ record }) =>
  record.face !== undefined ? (
    <img
      src={record.face.faceUrl}
      alt="faceUrl"
      style={{ width: '300px', padding: '1em' }}
    />
  ) : (
    <div />
  );

const LinkedOption = ({ record }) => {
  if (record.isFake)
    return <CheckboxGroupInput source="linked" choices={admin_users} />;
  else return null;
};

export const UserEdit = (props) => (
  <Edit title={<UserTitle />} {...props}>
    <SimpleForm>
      <SelectInput
        source="status"
        choices={status_types}
        defaultValue="verified"
      />
      <SelectInput
        source="isFaceVerificated"
        choices={status_types}
        defaultValue="none"
      />
      <TextField source="face.pose" />
      <FaceImage />
      <LinkedOption />
      <ImageInput
        source="images"
        label="Profile pictures"
        accept="image/*"
        multiple
        placeholder={<p>Drop your images here</p>}
      >
        <UploadedImages />
      </ImageInput>
      <TextInput disabled source="id" />
      <TextInput source="vipExpiredAt" />
      <TextInput source="weight" />
      <TextInput source="diamond" />
      <TextInput source="name" validate={[required()]} />
      <SelectInput
        source="gender"
        choices={gender_typs}
        defaultValue="gender"
      />
      <SelectInput
        source="interestedGender"
        choices={gender_typs}
        defaultValue="interestedGender"
      />
      <CheckboxGroupInput
        source="purpose"
        choices={purpose_types}
        validate={[required('Please select at least one purpose')]}
      />
      <TextInput source="areaCode" />
      <TextInput source="phone" />
      <DateInput source="birthday" />
      <ArrayInput source="metas" defaultValue={initalMetas}>
        <SimpleFormIterator>
          <TextInput source="question.name" label="Question name" disabled />
          <TextInput source="question.type" label="Input value type" disabled />
          <TextInput
            source="question.values"
            label="Input values selection"
            multiline
            disabled
          />
          <TextInput source="answer" label="Answer" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);
